import React from 'react';
import { connect } from 'react-redux';
import { isNull, isDate, compact } from 'lodash';
import * as actions from 'actions/assign';
import { pluralize } from 'utils/string_utils';
// eslint-disable-next-line import/no-cycle
import { formatDate } from './Review';
import { renderOptions, ListBlock } from './ReviewMobileList';

const ReviewMobile = ({
  uniqueUsersCount,
  assignees,
  content,
  schedule,
  setActiveStep,
  ...props
}) => {
  const scheduleOptions = compact([
    props.canSchedule && isNull(schedule.assignDate) && 'Assigned Immediately',
    props.canSchedule &&
      isDate(schedule.assignDate) &&
      `Assign on ${formatDate(schedule.assignDate)}`,
    schedule.dueDate && `Due ${formatDate(schedule.dueDate)}`,
    !schedule.dueDate && 'No due date',
    schedule.recurring && 'Recurring',
  ]);

  return (
    <div className="u-showBelowXS AssignMobileReview">
      <ListBlock
        header={`${content.length} ${pluralize(
          content.length,
          'Item',
        )} to be assigned`}
        onEdit={() => setActiveStep('CONTENT')}
        options={renderOptions(content, 'title')}
      />
      <ListBlock
        header={`${uniqueUsersCount} total assignees`}
        onEdit={() => setActiveStep('ASSIGNEES')}
        options={renderOptions(assignees, 'name')}
      />
      <ListBlock header="Scheduling" onEdit={() => setActiveStep('SCHEDULING')}>
        {renderOptions(scheduleOptions)}
      </ListBlock>
    </div>
  );
};

const mapStateToProps = state => ({
  uniqueUsersCount: state.selection.assignees.count,
  assignees: state.selection.assignees.data,
  content: state.selection.content.data,
  schedule: state.schedule,
  canSchedule: state.meta.features.scheduled_assignments,
});

const mapDispatchToProps = {
  setActiveStep: actions.setActiveStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewMobile);
